import { safeJsonResponse } from "@utils/safeJsonResponse";

export interface RegionResponse {
  region: string;
}

export interface ApiResponse<T> {
  response: T;
}

export const getRegion = async (): Promise<ApiResponse<RegionResponse>> => {
  const response = await fetch(`/api/region`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
    },
  });

  // QC-016: guard against empty/invalid response bodies instead of letting
  // response.json() throw `Unexpected end of JSON input`.
  const payload = await safeJsonResponse<ApiResponse<RegionResponse>>(response);

  if (!response.ok || !payload) {
    throw new Error("Error fetching region");
  }

  return payload;
};
